import { ReactNode } from 'react';
import { Checkbox } from 'antd';
import styled from 'styled-components';

const Container = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 100%;
  justify-content: space-between;

  page-break-before: auto;
  -webkit-page-break-before: auto;
  -moz-page-break-before: auto;

  page-break-inside: avoid;
  -webkit-page-break-inside: avoid;
  -moz-page-break-inside: avoid;
`;

const StyledCheckbox = styled(Checkbox)`
  span {
    font-size: 16px;
  }
  .ant-checkbox-wrapper {
    color: #333;
  }

  .ant-checkbox-inner {
    border-color: #333;
    width: 14px;
    height: 14px;
    &:after {
      border-color: #fff;
    }
  }

  .ant-checkbox-inner::after {
    top: 60%;
    left: 30%;
    width: 4px;
    height: 5px;
    border-width: 1px;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #333;
    border-color: #333;
  }

  .ant-checkbox-checked .ant-checkbox-inner::after {
    border-color: #fff;
  }

  &:hover .ant-checkbox-inner {
    border-color: #333;
  }
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #333;
  }
`;

const TitleStringWrap = styled('span')`
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: break-word;

  font-size: 18px;
`;

interface CheckboxWithTitleForPdfProps {
  title: ReactNode;
  value: boolean | null;
  onChange?: (value: boolean) => void;
  disabled?: boolean;
}

const CheckboxWithTitleForPdf = ({
  title,
  value,
  onChange,
  disabled
}: CheckboxWithTitleForPdfProps) => {
  const handleCheckboxChange = (checked: boolean) => {
    onChange?.(checked);
  };

  return (
    <Container>
      {typeof title === 'string' ? <TitleStringWrap>{title}</TitleStringWrap> : title}
      <div style={{ whiteSpace: 'nowrap' }}>
        <StyledCheckbox
          checked={value === true}
          onChange={() => handleCheckboxChange(true)}
          disabled={disabled}>
          Có
        </StyledCheckbox>
        <StyledCheckbox
          checked={value === false}
          onChange={() => handleCheckboxChange(false)}
          disabled={disabled}>
          Không
        </StyledCheckbox>
      </div>
    </Container>
  );
};

export default CheckboxWithTitleForPdf;
